module.exports = __webpack_public_path__ + "static/media/breathability_icon.5b8e66c8.png";